import { FieldLayoutViewModel } from 'src/app/models/field/field-layout-view-model.model';
import { QuickLink } from 'src/app/models/quick-link-model';

export class LayoutQuickLink extends QuickLink {

  private layout: FieldLayoutViewModel;

  constructor(layout: FieldLayoutViewModel) {
    super();
    this.layout = layout;
    this.title = layout.displayTitle;
    this.createdById = layout.modifiedByUserId;
    this.dateTimeCreated = layout.modifiedDateTime;
    this.isPinned = layout.isPinned;
    this.isShared = layout.isShared;
    this.lifeCycle = 0;
  }

  getLayout(): FieldLayoutViewModel {
    this.layout.displayTitle = this.title;
    this.layout.isPinned = this.isPinned;
    this.layout.isShared = this.isShared;
    return this.layout;
  }
}
